import React from "react";
import classNames from "classnames";
import {SectionTilesProps} from "../../utils/SectionProps";
import Image from "../elements/Image";
import { withTranslation } from "react-i18next";

import './section6Style.scss';

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};

const Section6 = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "testimonial section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap", pushLeft && "push-left");

  const content = {
    title: "+13 countries tracked",
    countries : [
      {name : "france"},
      {name : "canada"},
      {name : "portugal"},
      {name : "argentina"},
      {name : "brazil"},
      {name : "germany"},
      {name : "united-kingdom"},
      {name : "russia"},
      {name : "ukraine"},
      {name : "sweden"}
    ]
  };

  const {id} = props;

  return (
    <section id={id} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className="center-content">
            <h2>{content.title}</h2>
            <div className={tilesClasses}>
              <div className="slider center-content">
                <div className="slide-track">
                  {
                    content.countries.map((country, index) =>{
                      return (
                        <div className="slide" key={index}>
                          <img src={require("./../../assets/images/flags/"+country.name+".svg")} height="50" width="50" alt={country.name+"-flag"} />
                        </div>
                      )})
                  }
                </div>
              </div>
            </div>
          </div>
          <div  className="reveal-from-bottom" data-reveal-delay="200">
            <Image
              src={require("./../../assets/images/map.svg")}
              alt="Hero"
              style={{maxWidth:"80%", margin:"auto", alignContent:"center"}}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

Section6.propTypes = propTypes;
Section6.defaultProps = defaultProps;

export default withTranslation()(Section6);
